import { useState } from "react";
import styled from "styled-components";
import OSHighwaysLayer from "./OSHighways";
import OSHighwaysAction from "./OSHighwaysAction";
import OSHighwaysFileSummary from "./OSHighwaysFileSummary";

enum Tabs {
  IMPORT_TABLE = "import-table",
  FILE_SUMMARY = "file-summary",
  ACTIONS = "actions",
}

const StyledLink = styled.a`
  cursor: default;
`;

const OSHighwaysNavigation = () => {
  const [currentTab, setCurrentTab] = useState(Tabs.IMPORT_TABLE);

  const renderTab = (tab: Tabs) => {
    switch (tab) {
      case Tabs.IMPORT_TABLE:
        return <OSHighwaysLayer />;
      case Tabs.FILE_SUMMARY:
        return <OSHighwaysFileSummary />;
      case Tabs.ACTIONS:
        return <OSHighwaysAction />;
    }
  };

  return (
    <>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <StyledLink
            className={
              currentTab === Tabs.IMPORT_TABLE
                ? "nav-link active cursor-pointer"
                : "nav-link cursor-pointer"
            }
            onClick={() => setCurrentTab(Tabs.IMPORT_TABLE)}>
            Imports
          </StyledLink>
        </li>
        <li className="nav-item">
          <StyledLink
            className={
              currentTab === Tabs.FILE_SUMMARY
                ? "nav-link active cursor-pointer"
                : "nav-link "
            }
            onClick={() => setCurrentTab(Tabs.FILE_SUMMARY)}>
            File Summary
          </StyledLink>
        </li>
        <li className="nav-item">
          <StyledLink
            className={
              currentTab === Tabs.ACTIONS
                ? "nav-link active"
                : "nav-link "
            }
            onClick={() => setCurrentTab(Tabs.ACTIONS)}>
            Actions
          </StyledLink>
        </li>
      </ul>
      <>
        <div className="mt-2"></div>
        {renderTab(currentTab)}
      </>
    </>
  );
};

export default OSHighwaysNavigation;
